import React from 'react';

export function getVerificationBadgeSpan(type) {
  if (type === undefined || type === null) {
    return ('');
  }

  switch (type) {
    case 'BUSINESS':
      return (
          <span className="ico_plus">공식계정</span>
      );
    case 'PUBLIC_INSTITUTION':
    case 'CELEBRITY':
      return (
          <span className="ico_plus ico_badge">공공기관 및 유명인</span>
      );
    case 'NONE':
    default:
      return ('');
  }

}

export function getVerificationBadgeClassName(type) {
  if (type === undefined || type === null) {
    return ('');
  }

  switch (type) {
    case 'BUSINESS':
      return 'ico_biz'
    case 'PUBLIC_INSTITUTION':
    case 'CELEBRITY':
      return 'ico_public'
    case 'NONE':
    default:
      return ('');
  }

}



// WEBPACK FOOTER //
// ./src/utils/profileUtils.js